<template>
  <scoped>
    <VerticalNavigator>
      <h1>
        RutSolve
      </h1>
      <p>
        This application is still under construction,
        <br>
        but expect things to come!
      </p>
      <p>
        RutSolve will help entrepreneurs with tedious administrative tasks,
        <br>
        like creating orders, invoices, offers and more!
      </p>
    </VerticalNavigator>
  </scoped>
</template>

<script setup lang="ts">
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
</script>
